/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap.min.js');

// Optional Vendor Requires
require('./vendor/imagesloaded.pkgd.min.js');
// require('./vendor/jquery.actual.min');
// require('./vendor/jquery.validate.min');
// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
require('./vendor/slick.min.js');
// require('./vendor/youtube-iframe-assistant');
// require('./vendor/picturefill');
// require('./vendor/waypoint');
// require('./vendor/waypoint-animate');
// require('./vendor/modernizr.min.js');
require('./vendor/ss-standard.js');

// Sliders
// require('./app/sliders/slider-features');

// ScrollTrigger
// require('./app/scrollTrigger);

// App Requires
// require('./app/config');
// require('./app/helpers');
require('./app/global');
require('./app/primary-navigation');
require('./app/home-hero');